import supabase from '../supabaseClient';

/**
 * Redirects the user to Google, Microsoft, or Apple OAuth. After auth, Supabase redirects
 * back to redirectTo (must be in Supabase dashboard Redirect URLs).
 * @param {'google' | 'azure' | 'apple'} provider - 'google', 'azure' (Microsoft), or 'apple'
 * @param {string} [redirectTo] - Full URL to return to after OAuth (default: current page)
 * @returns {Promise<{ error: Error | null }>}
 */
export async function signInWithOAuth(provider, redirectTo = window.location.origin + window.location.pathname) {
  const desktopOAuth = typeof window !== 'undefined' && window.statboxDesktop?.openOAuth;
  const options = { redirectTo };
  if (desktopOAuth) {
    options.skipBrowserRedirect = true;
  }

  if (provider === 'azure') {
    // Microsoft must return an email to Supabase — request openid + email + profile.
    options.scopes = 'openid email profile';
    options.queryParams = { prompt: 'select_account' };
  }

  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options,
  });
  if (error) return { error };
  if (data?.url) {
    if (desktopOAuth) {
      await window.statboxDesktop.openOAuth(data.url);
      return { error: null };
    }
    window.location.href = data.url;
  }
  return { error: null };
}
